import React from 'react';
import { Dropdown } from 'react-bootstrap';

const AddressDropdown = ({ addresses, selectedAddress, onSelectAddress, id }) => {
    return (
        <div className="address-dropdown">
            <Dropdown>
                <Dropdown.Toggle variant="success" id={id || "dropdown-address"}>
                    {selectedAddress
                        ? `${selectedAddress.address}, ${selectedAddress.city}${selectedAddress.district ? `, ${selectedAddress.district}` : ''}, ${selectedAddress.state}, ${selectedAddress.zipCode}, ${selectedAddress.country}`
                        : 'Selecciona una dirección'}
                </Dropdown.Toggle>
                <Dropdown.Menu>
                    {addresses.map((address) => (
                        <Dropdown.Item
                            key={address.id} // Usamos address.id como key
                            onClick={() => onSelectAddress(address)} // Cuando el usuario seleccione una dirección
                            active={selectedAddress && selectedAddress.id === address.id} // Marcar como activo la dirección seleccionada
                        >
                            <span
                                style={{
                                    fontWeight: address.isDefault ? 'bold' : 'normal' // Resaltar la dirección predeterminada
                                }}
                            >
                                {`${address.address}, ${address.city}${address.district ? `, ${address.district}` : ''}, ${address.state}, ${address.zipCode}, ${address.country}`}
                                {address.isDefault && ' (Predeterminada)'}
                            </span>
                        </Dropdown.Item>
                    ))}
                </Dropdown.Menu>
            </Dropdown>
        </div>
    );
};

export default AddressDropdown;
